import { Box, Container, Stack, Typography, Grid } from '@mui/material';
import { dataBeneficio } from "../../data/data";
import tratamiento1 from "../../assets/Membership/Benefits/img7.png";
import tratamiento2 from "../../assets/Membership/Benefits/img8.png";
import imagenBackground from "../../assets/Membership/Benefits/background.png";

const brandBnfo = () => {
  return (
    <Box className="fullWidth" sx={{
      backgroundPositionX: {xs: "-600px", sm:"0"},
      backgroundSize: "cover",
      pt: "24px",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${imagenBackground})`,
    }}>

      <Container className="centeredContainer"
        sx={{
          justifyContent: "center",
          position: "relative",
          pb:"24px",
          gap:"24px",
        }}
      >

        <Typography variant="h2" sx={{
          margin: "-48px 0px 0px",
          fontSize: "26px",
          lineHeight: 1.2,
          textAlign: "center",
          borderRadius: "20px 5px",
          padding: "9.6px",
          fontWeight: 900,
          backgroundColor: "rgb(24, 36, 107)",
          color: "rgb(255, 255, 255)",
          width: {xs: "100%", md:"55%", lg:"25%"},
        }}>
          ¡Grandes beneficios para toda la familia!
        </Typography>

        <Box sx={{
          width: {xs: "100%", md:"60%"},
          textAlign: "center",
        }}>

          <Typography variant="h5" sx={{
            color: "rgb(255, 255, 255)",
            fontWeight: 400,
            lineHeight: 1.167,
            margin: 0,
            fontSize: {xs: "20px", md:"26px", lg:"30px"},
          }}>
            Con Salud365 accede a beneficios como:
          </Typography>
        </Box>

        <Grid container spacing={4}
          sx={{
            display: "flex",
            flexFlow: "wrap",
            width: "100%",
            justifyContent: {xs: "space-between", md:"center"},
            maxWidth: {xs: "100%", lg:"80%"},
            margin: "0 !important",
          }}  
        >
          {dataBeneficio.map((item, index) => (
            <Grid item xs={6} sm={6} md={4} key={index} sx={{
              padding: "0 !important",
              paddingLeft: "0",
              paddingRigt: "0",
            }}>
              <Box
                sx={{
                  padding: {xs: "8px", lg:"24px"},
                }}  
              >
                <Stack display="flex" flexDirection="row" textAlign="center">
                  <Box sx={{
                    margin: "0",
                  }}>
                    <Box sx={{
                      bgcolor:"rgb(109, 219, 86)",
                      borderRadius:"50%",
                      height:"56px",
                      width:"56px",
                      padding:"15.2px"
                    }}>
                      <img src={item.icono} alt="icono" loading="lazy" width="100%" height="100%"/> 
                    </Box>
                  </Box>
                  
                  <Typography variant="h4" textAlign="left" 
                  sx={{ 
                    fontSize: {xs: "12px", sm:"16px", md: "18px"}, 
                    ml:"8px",
                    fontWeight: "400",
                    lineHeight: "1.43",
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    color: "rgb(255, 255, 255)",
                  }}>
                    {item.texto}
                  </Typography>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: {xs: "column", sm:"row",},
          width: {xs: "100%", lg: "62%"}
        }}>

          <Box
            component="img"
            src={tratamiento1}
            alt="imagen Benefits"
            loading="lazy"
            sx={{
              objectFit: "fill",
              mb: "0",
              height: {xs: "100%"},
              width: {xs: "100%", sm:"49%", lg:"48%"},
              marginBottom: {xs: "10px", md:"0"},
              maxWidth: {xs:"400px", sm:"500", md:"none"}
            }}
          />
          <Box
            component="img"
            src={tratamiento2}
            alt="imagen Benefits"
            loading="lazy"
            sx={{
              objectFit: "fill",
              mb: "0",
              height: {xs: "100%"},
              width: {xs: "100%", sm:"49%", lg:"48%"},
              maxWidth: {xs:"400px", sm:"500", md:"none"}
            }}
          />
        </Box>

        <Typography variant="h6" 
        sx={{
          color: "rgb(255, 255, 255)",
          textAlign: "center",
          fontWeight: 500,
          lineHeight: 1.2,
          margin: 0,
          width: {xs:"100%", md:"75%", lg:"35%"},
          fontSize: {xs: "8px", md:"12px"},
          marginTop: {xs:"-16px", md:"-12px"},
        }}>
            *Aplican restricciones. Los beneficios finales se especifican en su contrato y varían de acuerdo al tipo de plan contratado. Consulte términos y condiciones de nuestros planes.
        </Typography>

      </Container>
    </Box>
  );
};

export default brandBnfo;
